{
  "version": 1,
  "asset_id": "784202e6-93d6-4135-af88-5fd73b0bd4ea",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/784202e6-93d6-4135-af88-5fd73b0bd4ea/sleeve-ugi-dilated-800.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/784202e6-93d6-4135-af88-5fd73b0bd4ea/sleeve-ugi-dilated-800.webp",
  "original_filename": "sleeve-ugi-dilated-800.webp",
  "size": 34928,
  "content_type": "image/webp",
  "created_at": "2026-09-28T01:31:13Z"
}
